import React, { Fragment } from 'react'
import classnames from 'classnames'
import { formatNumber } from '../../utils/utils'

import Button from '../../components/Button'
import Product from './components/SelectedMeal'
import NoMeals from './components/NoMeals'

import CloseImg from '../../assets/img/xclose.png'
import './SelectedMeals.css'

const SelectedMeals = props => {
  const {
    isOpen,
    onClose,
    className,
    style,
    isLoading,
    noAnimation,
    clearOrder,
    removeProduct,
    addProduct,
    products,
    subtotal,
    mealCount,
    onCheckout,
    orderSummaryLoading
  } = props

  return (
    isOpen && (
      <div
        className={classnames('cookunity__selected_meals_wrapper', className)}
        style={style}
        onClick={onClose}>
        <div
          className={classnames('cookunity__selected_meals', { noAnimation })}
          onClick={e => e.stopPropagation()}>
          <div className="header">
            <img
              className="close"
              src={CloseImg}
              alt="close"
              onClick={onClose}
            />

            <p className="label">My cart</p>

            <span
              className={classnames('clear_all', {
                disabled: mealCount <= 0
              })}
              onClick={() => {
                if (mealCount > 0) {
                  clearOrder()
                }
              }}>
              Clear all
            </span>
          </div>

          <div className={classnames('content', { loading: isLoading })}>
            {!isLoading &&
              (products.length > 0 ? (
                <Fragment>
                  {products.map(product => (
                    <Product
                      key={product.id}
                      product={product}
                      removeProduct={removeProduct}
                      addProduct={addProduct}
                    />
                  ))}

                  <Button
                    large
                    block
                    onClick={onClose}
                    style={{ width: '100%', marginTop: 40 }}>
                    Add more items
                  </Button>
                </Fragment>
              ) : (
                <NoMeals />
              ))}
          </div>

          <div className="footer">
            <div className="subtotal">
              <span>
                Subtotal: <strong>${formatNumber(subtotal)}</strong>
              </span>
            </div>
            <Button
              dark
              large
              className="checkout_button"
              disabled={!mealCount}
              loading={orderSummaryLoading}
              onClick={onCheckout}>
              Checkout
            </Button>
          </div>
        </div>
      </div>
    )
  )
}

export default SelectedMeals



// WEBPACK FOOTER //
// ./src/components/SelectedMeals/SelectedMeals.jsx